export default __webpack_public_path__ + "static/media/currencyThumb.b0053c9c.png";